<template>
    <div>
        <vx-card title="Accreditation" subtitle="Lists of Accredited Affiliates"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewAccreditation()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="employeeAccreditation">
                    <template slot="thead">
                        <vs-th>Accreditation Type</vs-th>
                        <vs-th>Rank</vs-th>
                        <vs-th>Issued By</vs-th>
                        <vs-th>Date Attained</vs-th>
                        <vs-th>Rating</vs-th>
                        <vs-th>Cert No</vs-th>
                        <vs-th>Date Expired</vs-th>
                        <vs-th>Remarks</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].accreditationTypeId">
                                {{ accreditationTypeName(data[indextr].accreditationTypeId).accreditationTypeName }}
                            </vs-td>
                            <vs-td :data="data[indextr].rankId">
                                {{ rankName(data[indextr].rankId).rankName }}
                            </vs-td>
                            <vs-td :data="data[indextr].issuedby">
                                {{data[indextr].issuedby}}
                            </vs-td>
                            <vs-td :data="data[indextr].dateAttained">
                                {{data[indextr].dateAttained | fulldate }}
                            </vs-td>
                            <vs-td :data="data[indextr].rating">
                                {{data[indextr].rating}}
                            </vs-td>
                            <vs-td :data="data[indextr].certificationNo">
                                {{data[indextr].certificationNo}}
                            </vs-td>
                            <vs-td :data="data[indextr].dateExpired">
                                {{data[indextr].dateExpired | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].remarks">
                                {{data[indextr].remarks}}
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD ACCREDITATION -->
            <vs-prompt
                class="email-compose"
                title="Accreditation"
                accept-text= "Submit"
                @accept="onAddAccreditation"
                :is-valid="validForm"
                :active.sync="activePromptNewAccreditation">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Accreditation Type</span><span style="color:red">*</span>
                        <v-select name="accreditationType-name" v-model="accreditationType" label="accreditationTypeName" :options="getAccreditationType" placeholder="Please Select"/>

                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                        <span  class="text-sm">Rank</span><span style="color:red">*</span>
                        <v-select name="rank-name" v-model="rank" label="rankName" :options="getRank" placeholder="Please Select"/>
                        
                    </div>
                    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                        <span  class="text-sm">Rating</span>
                        <vs-input v-validate="'numeric|max_value:100'"   class="w-full" name="rating" v-model="rating" placeholder="Rating"/>
                        <span class="text-danger text-sm" v-show="errors.has('rating')">{{ errors.first('rating') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Attained</span>
                    <datepicker :format="format" v-model="dateAttained" placeholder="Select Date"/>

                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4" >
                        <span  class="text-sm">Date Expired</span>
                        <datepicker :format="format" v-model="dateExpired" placeholder="Select Date"/>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full mb-2" >
                        <span  class="text-sm">Certification No</span>
                        <vs-input name="cert-name" class="w-full" v-model="certificationNo" placeholder="Certification No"/>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full mb-2">
                        <span  class="text-sm">Issued By</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="issued by" class="w-full" v-model="issuedBy" placeholder="Issued By"/>
                        <span class="text-danger text-sm" v-show="errors.has('issued by')">{{ errors.first('issued by') }}</span>


                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <span class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>

            
                </vx-card>
            </vs-prompt>




                 <!-- EDIT ACCREDITATION -->
            <vs-prompt
                class="email-compose"
                title="Accreditation"
                accept-text= "Submit"
                @accept="onEditAccreditation"
                :is-valid="validForm"
                :active.sync="activePromptEditAccreditation">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Accreditation Type</span><span style="color:red">*</span>
                        <v-select name="accreditationType-name" v-model="accreditationType" label="accreditationTypeName" :options="getAccreditationType"/>

                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                        <span  class="text-sm">Rank</span><span style="color:red">*</span>
                        <v-select name="rank-name" v-model="rank" label="rankName" :options="getRank" placeholder="Rank"/>
                    </div>
                    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 w-full mb-2">
                        <span  class="text-sm">Rating</span>
                       <vs-input v-validate="'numeric|max_value:100'"   class="w-full" name="rating" v-model="rating" placeholder="Rating"/>
                        <span class="text-danger text-sm" v-show="errors.has('rating')">{{ errors.first('rating') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Attained</span>
                    <datepicker :format="format" v-model="dateAttained" placeholder="Select Date"/>

                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4" >
                        <span  class="text-sm">Date Expired</span>
                        <datepicker :format="format" v-model="dateExpired" placeholder="Select Date"/>

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full mb-2" >
                        <span  class="text-sm">Certification No</span>
                        <vs-input name="cert-name" class="w-full" v-model="certificationNo" placeholder="Certification No"/>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-full mb-2">
                        <span  class="text-sm">Issued By</span>
                        <vs-input v-validate="'alpha_spaces|max:50'" name="issued by" class="w-full" v-model="issuedBy" placeholder="Issued By"/>
                        <span class="text-danger text-sm" v-show="errors.has('issued by')">{{ errors.first('issued by') }}</span>

                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <span class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>

            
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            id                  : 0,
            accreditationType   : [],
            rank                : [],
            issuedBy            : '',
            dateAttained        : null,
            rating              : null,
            certificationNo     : '',
            dateExpired         : null,
            remarks             : '',
            userId              : null,

            uid                 : null,
            activePromptNewAccreditation    : false,
            activePromptEditAccreditation    : false,

            format: "d MMMM yyyy",
        }
    },
    created() {
            this.$vs.loading()
            // this.$store.dispatch('hrms/getAllAccreditation', { userId : null})
            this.$store.dispatch('lookup/getAllAccreditationType')
            this.$store.dispatch('lookup/getAllRankLookup')
                .then(res => { this.$vs.loading.close() })
                .catch(error => { 
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                        })
                })
            this.uid = this.$route.params.id
            this.employeeAccreditation = this.uid
            //  this.$store.dispatch('hrms/getAllAccreditation',  this.uid )
            
    },
    computed: {
        employeeAccreditation: {
           
           get() { return this.$store.state.hrms.employeeAccreditation },
           set(value) { this.$store.dispatch('hrms/getAllAccreditation',  value )}
            
        },
        validForm(){
            return this.accreditationType.accreditationTypeId !=null && this.rank.rankId !=null 
        },
        getAccreditationType() {
            return this.$store.state.lookup.getAllAccreditationType
        },
        getRank() {
             return this.$store.state.lookup.getAllRankLookup
        },
        accreditationTypeName() {
            return (id) => this.$store.getters['lookup/accreditationType'](id)
        },
        rankName(){
            return (id) => this.$store.getters['lookup/rankLookup'](id)
        }
    },
    methods: {
        promptAddNewAccreditation() {
            this.activePromptNewAccreditation = true
        },
        onAddAccreditation() {
            this.$validator.validateAll().then(result => {
            if (result) {
                    this.$vs.loading()

                    const data = {
                        accreditationTypeId: this.accreditationType.accreditationTypeId,
                        rankId: this.rank.rankId,
                        issuedby: this.issuedBy,
                        dateAttained: this.dateAttained,
                        rating: this.rating,
                        certificationNo: this.certificationNo,
                        dateExpired: this.dateExpired,
                        remarks: this.remarks,
                        userId: this.uid,
                        currentUserId: this.$store.state.AppActiveUser.uid
                    }

                    this.$store.dispatch('hrms/AddAccreditation', data)
                    .then((response) =>{
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Accredition Saved',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                 } else {
                    // form have errors
                    this.$vs.notify({
                                title: 'Error',
                                text: error.message,
                                iconPack: 'feather',
                                icon: 'icon-x-octagon',
                                color: 'danger'
                            })
                }
                })
        },
        onEditAccreditation() {
            this.$validator.validateAll().then(result => {
            if (result) {
                const data = {
                    id                      : this.id,
                    accreditationTypeId     : this.accreditationType.accreditationTypeId,
                    rankId                  : this.rank.rankId,
                    issuedby                : this.issuedBy,
                    dateAttained            : this.dateAttained,
                    rating                  : this.rating,
                    certificationNo         : this.certificationNo,
                    dateExpired             : this.dateExpired,
                    remarks                 : this.remarks,
                    userId                  : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('hrms/UpdateAccreditation', data)
                    .then(response => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Accreditation Updated',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                 } else {
                    // form have errors
                    this.$vs.notify({
                                title: 'Error',
                                text: error.message,
                                iconPack: 'feather',
                                icon: 'icon-x-octagon',
                                color: 'danger'
                            })
                }
                })
        },
        editRecord(Id) {

            const e = this.$store.getters['hrms/employeeAccreditation'](Id)
            this.id = e.id,
            this.accreditationType = this.accreditationTypeName(e.accreditationTypeId),
            this.rank = this.rankName(e.rankId),
            this.issuedBy = e.issuedby,
            this.dateAttained = e.dateAttained,
            this.rating = e.rating,
            this.certificationNo = e.certificationNo,
            this.dateExpired = e.dateExpired,
            this.remarks = e.remarks
            this.userId = e.userId

            this.activePromptEditAccreditation = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteAccreditation', id)
            .then(res => {
                this.$vs.loading.close()
                        this.employeeAccreditation = this.uid
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Accreditation Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>